import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { productLabel } from '../modules/sales/Prices/priceLookupShared';
import './StyledInput.css';

// Consumable Product picker for a Packaging entry (Warehouse › Packaging):
// a plain text search + dropdown over /api/products, scoped to the
// Consumable Product Type (code C), so a box or satchel can be identified
// by its SKU and reordered through that Product.
function PackingProductPicker({ value, onChange, placeholder = 'Search Consumable SKU...', style }) {
  const [search, setSearch] = useState(value ? productLabel(value) : '');
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [consumableProductTypeId, setConsumableProductTypeId] = useState('');
  const timer = useRef(null);

  useEffect(() => {
    axios.get('/api/product-types')
      .then((res) => {
        const consumable = (res.data.data || []).find((pt) => pt.code === 'C');
        setConsumableProductTypeId(consumable ? String(consumable.id) : '');
      })
      .catch(() => setConsumableProductTypeId(''));
  }, []);

  // Keeps the box in sync when the caller resets/loads `value` out from
  // under it, not just on the user's own typing/selecting.
  useEffect(() => {
    setSearch(value ? productLabel(value) : '');
  }, [value]);

  const handleChange = (text) => {
    setSearch(text);
    if (value) onChange(null);
    clearTimeout(timer.current);
    if (!text.trim()) {
      setResults([]);
      return;
    }
    timer.current = setTimeout(() => {
      axios.get('/api/products', { params: { search: text, status: 'active', product_type: consumableProductTypeId, limit: 10 } })
        .then((res) => { setResults(res.data.data || []); setShowResults(true); })
        .catch(() => setResults([]));
    }, 250);
  };

  const handleSelect = (product) => {
    setSearch(productLabel(product));
    setShowResults(false);
    onChange(product);
  };

  return (
    <div style={{ position: 'relative', ...style }}>
      <input
        className="styled-input"
        placeholder={placeholder}
        value={search}
        onChange={(e) => handleChange(e.target.value)}
        onFocus={() => { if (results.length) setShowResults(true); }}
        onBlur={() => setTimeout(() => setShowResults(false), 150)}
        style={{ width: '100%' }}
      />
      {showResults && results.length > 0 && (
        <ul style={{ position: 'absolute', zIndex: 10, top: '100%', left: 0, width: '100%', minWidth: 260, margin: 0, padding: 4, listStyle: 'none', background: '#fff', border: '1px solid #bfc8d6', borderRadius: 6, boxShadow: '0 2px 8px rgba(0,0,0,0.12)', maxHeight: 220, overflowY: 'auto' }}>
          {results.map((p) => (
            <li
              key={p.id}
              onMouseDown={() => handleSelect(p)}
              style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13, borderRadius: 4 }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#e3eaf3'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              {productLabel(p)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default PackingProductPicker;
